import { useQuery, useMutation, UseQueryOptions, UseQueryResult } from 'react-query'
import { QueryKeys } from './_query_keys'
import { useState } from 'react'
import { APIEndpoints } from '../constants/api-endpoints'
import { HttpRequest } from '../services/_http'

export const useLanguageOptions = (options?: UseQueryOptions): UseQueryResult<any, any> => {
    const method = 'GET'
    const queryKey = [QueryKeys.LANGUAGES, 'options']

    /** To keeping old data until response received with new data */
    const [keepPreviousData, setkeepPreviousData] = useState(true)

    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: `${APIEndpoints.Languages}`,
            method
        }),
        refetchOnWindowFocus: false,
        keepPreviousData,
        onError: () => setkeepPreviousData(false),
        onSuccess: () => setkeepPreviousData(true),
        ...options
    })
}

export const useLanguageData = (searchOptions?: any, options?: UseQueryOptions): UseQueryResult<any> => {

    const method = 'GET'
    const queryKey = [QueryKeys.LANGUAGES, searchOptions]
    /** To keeping old data until response received with new data */
    const [keepPreviousData, setkeepPreviousData] = useState(true)
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: APIEndpoints.Languages,
            params: searchOptions,
            method
        }),
        refetchOnWindowFocus: false,
        keepPreviousData,
        onError: () => setkeepPreviousData(false),
        onSuccess: () => setkeepPreviousData(true),
        ...options
    })
}

export const useAddLanguage = (options?: any) => {
    const method = 'POST'
    return useMutation(({data}: {data: any})=> HttpRequest({
        url: `${APIEndpoints.Languages}`,
        method,
        data
    }), options)
}

export const useUpdateLanguageData = (options?: any) => {
    const method = 'PUT'
    return useMutation(({ data, id }: { data: FormData, id: any }) => HttpRequest({
        url: `${APIEndpoints.Languages}/${id}`,
        method,
        data
    }), options)
}

export const useDeleteLanguageData = (options?: any) => {
    const method = 'DELETE'
    return useMutation(({id}: {id: any})=> HttpRequest({
        url: `${APIEndpoints.Languages}/${id}`,
        method,
    }), options)
}

export const useStatusLanguage = (options?: any) => {
    const method = 'PATCH'
    return useMutation(({data, id}: {data: FormData, id: any})=> HttpRequest({
        url: `${APIEndpoints.Languages}/${id}/status`,
        method,
        data
    }), options)
}

